module.exports = __webpack_public_path__ + "static/media/book11.64b9378f.jpg";